import { callApi } from ".";

const AdminLogin = (body) => {
  return callApi("auth/sign-in", "POST", {}, body, false);
};

export { AdminLogin };
